import { render, staticRenderFns } from "./Legislatura.vue?vue&type=template&id=66aa78ae&scoped=true"
import script from "./Legislatura.vue?vue&type=script&lang=js"
export * from "./Legislatura.vue?vue&type=script&lang=js"
import style0 from "./Legislatura.vue?vue&type=style&index=0&id=66aa78ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aa78ae",
  null
  
)

export default component.exports